import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { GeneralComponent } from '../../General/g.component';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../../shared/message.service';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { TopicService } from '../topic.service';

@Component({
  selector: 'app-open-question',
  templateUrl: './open-question.component.html',
  styleUrls: ['./open-question.component.css']
})
export class OpenQuestionComponent extends GeneralExerciseComponent {

  public solution = "";
  public question: string;
  code: string;
  showCode: string;

  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
  }

  setTypeSpecificsFromConfiguration() {
    if (this.configuration.typespecifics.question != undefined) {
      this.question = this.configuration.typespecifics.question;
    }
    this.solution = "";
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific.solution != undefined) {
      this.solution = this.state.typespecific.solution;
    }
  }

  computeState() {
    this.state.typespecific.solution = this.solution;
  }

  /** checks, whether the solution is correct and sends messages */
  checkSolution() {
   
      if (this.solution.length > 0) {
        this.messageService.addAlertWithTimeout(this.get("correct"), "success", 3000);
        this.solved = true;
        this.state.solved = true;
        this.saveState();
      } else {
        this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
      }
  }

  /** evaluates the current state of the exercise 
     * @returns {number} - returns the total number of points 
    */
  evaluate(): number[] {
    let result = 1;
    return [result, 1];
  }

  /** returns the expected solution based on the typespecific parts of the question */
  expectedSolution(): any {
   
  }


}
